import { apiSlice } from '../apiSlice';

import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	ExerciseSeriesPinnedDetailListDTO,
	ExerciseSeriesPinnedDTO,
	ExerciseSeriesPinnedFilter,
} from '../DTO/exercise/dingDay21.interface';

export const dingDay21ApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getDingDay21List: builder.query<
			SuccessResponse<ExerciseSeriesPinnedDTO[]>,
			null
		>({
			query: () => ({
				url: `/web/exercise/series/pinned/list`,
				method: 'GET',
			}),
			providesTags: ['DingDay21'],
		}),
		getDingDay21DetailList: builder.query<
			SuccessResponse<Paginated<ExerciseSeriesPinnedDetailListDTO>>,
			ExerciseSeriesPinnedFilter
		>({
			query: (body) => ({
				url: `/web/exercise/series/pinned/series-page`,
				method: 'POST',
				body,
			}),
		}),
		setDing: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/exercise/series/pinned`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['DingDay21'],
		}),
		setDingSort: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/exercise/series/pinned/sort`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['DingDay21'],
		}),
	}),
});

export const {
	useGetDingDay21ListQuery,
	useGetDingDay21DetailListQuery,
	useSetDingMutation,
	useSetDingSortMutation,
} = dingDay21ApiSlice;
